"use client";

import { ProductURLTypeProdProperty } from "@/view/products/product";

interface Attribute {
    name: string;
    value: string;
}

interface MainAttributeProps {
    data: ProductURLTypeProdProperty[];
    woman?: boolean
    man?: boolean
}

const MainAttribute = ({ data, woman, man }: MainAttributeProps) => {
    const filterAttribute = () => {
        const property = data
            .filter(
                (i) =>
                    i.Property.property_main === true &&
                    i.Property.property_name !== "غلظت"
            )
            .map((i) => {
                return {
                    name: i.Property.property_name,
                    value: i.Attribute.attribute_name,
                };
            });

        const result = Object.values(
            property.reduce(
                (acc: { [key: string]: { name: string; value: string } }, curr) => {
                    if (acc[curr.name]) {
                        acc[curr.name].value += ` , ${curr.value}`;
                    } else {
                        acc[curr.name] = { ...curr };
                    }
                    return acc;
                },
                {}
            )
        );
        return result;
    };

    const result = filterAttribute();
    return (
        <div>
            {result.map((item: Attribute) => (
                <div key={item.name} className="">
                    <div className={`flex flex-wrap items-center justify-between rounded-lg py-1 px-3 m-1 text-right`}>
                        <p className="border-b border-pink text-text text-sm text-nowrap">
                            {item.name}:
                        </p>
                        <p className="text-text1 text-sm">
                            {item.value}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MainAttribute;
